import { isObject } from '@enmon/commons';

export interface StrapiApiErrorResponse {
  error: {
    name: string;
    message: string;
    status: number;
    details?: Array<{
      path: string[];
      message: string;
      name: string;
    }>;
  };
}

export const isStrapiApiErrorResponse = (value: unknown): value is StrapiApiErrorResponse => {
  if (!isObject(value)) return false;

  const response = value as Record<keyof StrapiApiErrorResponse, unknown>;

  if (!isObject(response.error)) return false;

  const error = response.error as Record<keyof StrapiApiErrorResponse['error'], unknown>;

  return typeof error.name === 'string' && typeof error.message === 'string' && typeof error.status === 'number';
};
